var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInhumationIcone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6A7782;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-544 -437)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(544 437)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(554 449)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M115.023,18.18h-2.76V0H96.76V18.18H94v3.148h21.023ZM101.63,4.469h5.764V5.992H101.63Zm5.764,7.617H101.63V10.563h5.764Zm1.473-3.047h-8.709V7.516h8.709Z",
    transform: "translate(-89.227)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 30.57,
    height: 3.148,
    transform: "translate(0 22.852)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInhumationIcone);
export default __webpack_public_path__ + "static/media/inhumation-icone.3d8bf9f5fa732c2da2f7f791cc33c744.svg";
export { ForwardRef as ReactComponent };